export { applyAutoWiring } from './applyAutoWiring';
export { runRemoveWiring } from './runners/removeWiring';

export {
  INTERNAL_applyAutoWiring,
  INTERNAL_undoAutoWiring,
  INTERNAL_removeAllWiring,
} from './internal';
